import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { Heart, Paw, Star } from '../brand/Shapes';

const COLORS = ['#FF8A9B', '#FFB7B2', '#4D96FF', '#FFD166', '#9B7BD4'];
const SHAPES = { heart: Heart, paw: Paw, star: Star };

/** Dispara uma explosão de coraçõezinhos (ou patinhas/estrelas) na posição do clique. */
export const burst = (e, kind = 'heart', count = 9) => {
  if (typeof window === 'undefined') return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  let x = e?.clientX;
  let y = e?.clientY;
  if ((x === undefined || (x === 0 && y === 0)) && e?.currentTarget) {
    const r = e.currentTarget.getBoundingClientRect();
    x = r.left + r.width / 2;
    y = r.top + r.height / 2;
  }
  window.dispatchEvent(new CustomEvent('pet:burst', { detail: { x, y, kind, count } }));
};

/** Camada global que desenha as explosões (montada uma vez no App). */
export const BurstLayer = () => {
  const [bursts, setBursts] = useState([]);

  useEffect(() => {
    const on = (ev) => {
      const { x, y, kind, count } = ev.detail;
      const id = Math.random();
      const parts = Array.from({ length: count }, (_, i) => {
        const angle = (i / count) * Math.PI * 2 + Math.random() * 0.6;
        const dist = 50 + Math.random() * 50;
        return {
          i,
          dx: Math.cos(angle) * dist,
          dy: Math.sin(angle) * dist - 30,
          size: 12 + Math.random() * 12,
          rot: (Math.random() - 0.5) * 70,
          color: COLORS[i % COLORS.length],
        };
      });
      setBursts((b) => [...b, { id, x, y, kind, parts }]);
      setTimeout(() => setBursts((b) => b.filter((p) => p.id !== id)), 1100);
    };
    window.addEventListener('pet:burst', on);
    return () => window.removeEventListener('pet:burst', on);
  }, []);

  return createPortal(
    <div className="pointer-events-none fixed inset-0 z-[140]" aria-hidden="true">
      <AnimatePresence>
        {bursts.map((b) => {
          const Shape = SHAPES[b.kind] || Heart;
          return b.parts.map((p) => (
            <motion.span
              key={`${b.id}-${p.i}`}
              className="absolute"
              style={{ left: b.x, top: b.y, width: p.size, height: p.size, marginLeft: -p.size / 2, marginTop: -p.size / 2, color: p.color }}
              initial={{ x: 0, y: 0, scale: 0, rotate: 0, opacity: 1 }}
              animate={{ x: p.dx, y: [0, p.dy, p.dy + 40], scale: [0, 1.2, 0.9], rotate: p.rot, opacity: [1, 1, 0] }}
              transition={{ duration: 0.9, ease: 'easeOut' }}
            >
              <Shape className="w-full h-full" />
            </motion.span>
          ));
        })}
      </AnimatePresence>
    </div>,
    document.body
  );
};

export default BurstLayer;
